import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationItemsPerPage',
    props: {
        modelValue: { type: Number, required: true },
        allowedValues: { type: Array, required: false, default: () => [10, 25, 50, 100] },
        defaultValue: { type: Number, required: false, default: 25 },
        label: { type: String, required: false, default: "Ver" },
        selectId: { type: String, required: false, default: "pagination--items-per-page" }
    },
    emits: ["update:modelValue", "change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const allowedValues = computed(() => {
            // Ensure the default value is included in allowed values
            const values = [...props.allowedValues];
            if (!values.includes(props.defaultValue)) {
                values.push(props.defaultValue);
                values.sort((a, b) => a - b);
            }
            return values;
        });
        const handleChange = (event) => {
            const target = event.target;
            const newValue = parseInt(target.value);
            if (allowedValues.value.includes(newValue)) {
                emit("update:modelValue", newValue);
                emit("change", newValue);
            }
            else {
                // Reset to current value if invalid
                target.value = String(props.modelValue);
            }
        };
        const __returned__ = { props, emit, allowedValues, handleChange };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
